module.exports = "/_next/static/images/teacher-2-27174d3f8bbd1be070744900b7a8207c.png";